export default __webpack_public_path__ + "static/media/Chestguard of the Usurper.82e19577.jpg";